import axios from '../config/axiosConfig';

const API_URL = '/exposiq';
const PLATFORM_URL = '/platform-integrations';
const KEY_URL = '/integration-keys';

// Scan management
const getConnectionStatus = async (webTargetId) => {
  const response = await axios.get(`${API_URL}/connection-status`, { params: webTargetId ? { webTargetId } : {} });
  return response.data;
};

const triggerScan = async (webTargetId, config = {}) => {
  const response = await axios.post(`${API_URL}/trigger-scan/${webTargetId}`, config);
  return response.data;
};

const getDastEndpoints = async (webTargetId, profileId) => {
  const response = await axios.get(`${API_URL}/dast-endpoints/${webTargetId}`, { params: { profileId } });
  return response.data;
};

const pollScanStatus = async (exposiqScanId) => {
  const response = await axios.get(`${API_URL}/scan-status/${exposiqScanId}`);
  return response.data;
};

const stopScan = async (exposiqScanId) => {
  const response = await axios.post(`${API_URL}/stop-scan/${exposiqScanId}`);
  return response.data;
};

const importResults = async (webTargetId, exposiqScanId) => {
  const response = await axios.post(`${API_URL}/import-results/${webTargetId}`, { exposiqScanId });
  return response.data;
};

const getScanHistory = async (webTargetId) => {
  const response = await axios.get(`${API_URL}/scan-history/${webTargetId}`);
  return response.data;
};

// Platform integration config
const getIntegrations = async (platform) => {
  const response = await axios.get(PLATFORM_URL, { params: { platform } });
  return response.data;
};

const getIntegration = async (id) => {
  const response = await axios.get(`${PLATFORM_URL}/${id}`);
  return response.data;
};

const createIntegration = async (data) => {
  const response = await axios.post(PLATFORM_URL, data);
  return response.data;
};

const updateIntegration = async (id, data) => {
  const response = await axios.put(`${PLATFORM_URL}/${id}`, data);
  return response.data;
};

const deleteIntegration = async (id) => {
  const response = await axios.delete(`${PLATFORM_URL}/${id}`);
  return response.data;
};

// Integration key management
const getIntegrationKeys = async (platform) => {
  const response = await axios.get(KEY_URL, { params: { platform } });
  return response.data;
};

const generateIntegrationKey = async (data) => {
  const response = await axios.post(KEY_URL, data);
  return response.data;
};

const updateIntegrationKey = async (id, data) => {
  const response = await axios.put(`${KEY_URL}/${id}`, data);
  return response.data;
};

const revokeIntegrationKey = async (id) => {
  const response = await axios.delete(`${KEY_URL}/${id}`);
  return response.data;
};

const scanProfiles = [
  { key: 'quick', label: 'Quick Scan', description: 'Fast scan (~5 min) covering common vulnerabilities', duration: '~5 min' },
  { key: 'standard', label: 'Standard Scan', description: 'Comprehensive scan (~15 min) with moderate depth', duration: '~15 min' },
  { key: 'full', label: 'Full Scan', description: 'Deep scan (~45 min) covering all vulnerability categories', duration: '~45 min' }
];

const exposiqService = {
  getConnectionStatus,
  triggerScan,
  getDastEndpoints,
  pollScanStatus,
  stopScan,
  importResults,
  getScanHistory,
  getIntegrations,
  getIntegration,
  createIntegration,
  updateIntegration,
  deleteIntegration,
  getIntegrationKeys,
  generateIntegrationKey,
  updateIntegrationKey,
  revokeIntegrationKey,
  scanProfiles
};

export default exposiqService;
